import { render, staticRenderFns } from "./UserComponent.vue?vue&type=template&id=23db59bc&scoped=true&"
import script from "./UserComponent.vue?vue&type=script&lang=js&"
export * from "./UserComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23db59bc",
  null
  
)

export default component.exports